import { IBonusToDisplay } from '@core/js/components/main/BonusHistory/types';
import * as Types from 'js/components/main/BonusHistory/hooks/useTableData/types';
import { IMoneyInfo } from '@core/js/hooks/socket/types';
import { ITranslateMethod } from '@core/js/hooks/i18n/types';
import { isEmpty } from 'ramda';

export type FormattedRowsType = {
    translate: ITranslateMethod;
    additionalRows?: IBonusToDisplay[];
    formatCurrency: (data: IMoneyInfo) => string;
};

const getBetValue = (
    betConfigurations: { betValue: IMoneyInfo }[],
    formatCurrency: (data: IMoneyInfo) => string
) => betConfigurations?.[0]?.betValue ? formatCurrency(betConfigurations?.[0]?.betValue) : null;

const getValue = (value: object | string, path: string) => typeof value !== 'string' ? (value as object)?.[path as keyof object] : value;

export const getFormattedData = ({
    additionalRows = [],
    formatCurrency
}: FormattedRowsType) => (item: IBonusToDisplay) => {
    const bonusName = item.marketingName || item.templateName;
    const { betConfigurations } = item;

    return [
        {
            id: 0,
            value: (item.playableGameTypes && !isEmpty(item.playableGameTypes)) || item.isLoading || item.error
                ? { playableGameTypes: item.playableGameTypes, isLoading: item.isLoading, error: item.error }
                : null,
            type: Types.CELL_TYPE.GAMES
        },
        ...(betConfigurations?.[0]?.betValue ? [{
            id: 1,
            key: 'playtech.mobile.system.bonusDetail.freeSpinsAmount',
            value: getBetValue(betConfigurations, formatCurrency),
            type: Types.CELL_TYPE.DEFAULT
        }] : []),
        { id: 2, key: 'playtech.mobile.system.balance.pendingWinnings', value: getValue(item.pendingWinnings, 'amount'), type: Types.CELL_TYPE.DEFAULT },
        { id: 3, key: 'playtech.mobile.system.balance.freeSpinsCountTotal', value: item.freeSpinsCount, type: Types.CELL_TYPE.DEFAULT },
        { id: 4, key: 'playtech.mobile.system.balance.freeSpinsCountRemaining', value: item.freeSpinsCountRemaining, type: Types.CELL_TYPE.DEFAULT },
        { id: 5, key: 'playtech.mobile.system.balance.expireDate', value: item.endDate, type: Types.CELL_TYPE.DEFAULT },
        {
            id: 6,
            key: 'playtech.mobile.system.bonusDetail.tcTitle',
            value: item.popupWcId ? { popupWcId: item.popupWcId, popupTitle: item.popupTitle } : undefined,
            type: Types.CELL_TYPE.POPUP
        },
        {
            id: 7,
            key: 'playtech.mobile.system.bonusDetail.goldenChipsCountRemaining',
            value: item.isCancelButton
                ? { bonusName, bonusInstanceCode: item.bonusInstanceCode }
                : undefined,
            type: Types.CELL_TYPE.BUTTON
        },
        ...additionalRows
    ] as Types.IAccordionRow[];
};
